import { useEffect, useState } from "react";
import { Row, Col, Table } from "reactstrap";
import { getElectricityInfo } from "../../../api/api";
import Spinner from "../../../commons/Spinner";

const TableWeather = ({ selected, setSelected, deviceArr, deviceId }) => {
    const [pcsData, setPcsData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const authToken = localStorage.getItem('accessToken');

    useEffect(() => {
        setPcsData(null);
        setIsLoading(true);
        const controller = new AbortController();
        const signal = controller.signal;
        const fetchData = async (signal) => {
            const data = await getElectricityInfo(authToken, deviceId, selected, signal);
            if (typeof data !== 'undefined') {
                setPcsData({
                    solar_radiation: 0,
                    temperature: 0,
                    temperature_2: 0,
                });
            }
            setIsLoading(false);
        };
        const interval = setInterval(() => {
            fetchData(signal);
        }, 60000);
        fetchData(signal);

        return () => {
            clearInterval(interval);
            controller.abort();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected]);

    return (
        <>
            {/* <DeviceInfoNav {...props} /> */}
            {isLoading ? <Spinner /> : <Row>
                <Col md={2} lg={2} sm={2} xl={1} className="col-2 d-flex flex-row justify-content-end arrow-menu h-100">
                    <div>
                        <button
                            className="btn_back"
                            onClick={() => setSelected(null)}
                        >
                            <img src="/img/left.png" alt="leftArrow" className="m-2" />
                        </button>
                    </div>
                    <div className="vl"></div>
                </Col>

                <Col md={10} lg={10} sm={10} xl={11} className="col-9">
                    <Row className="d-flex flex-row mx-1">
                        <div className="dropDown">
                            <select
                                type="select"
                                size="sm"
                                className="btn__dropdown"
                                value={selected.device_id}
                                onChange={(e) => setSelected(deviceArr.filter(el => (el.device_id === e.target.value))[0])}
                            >
                                {(deviceArr.length > 0) && deviceArr.map((el, i) => <option value={el.device_id} key={i} > {el.device_id} </option>)}
                            </select>
                        </div>
                        <div className="batteryBox">
                            <div className="colBorder mmr">
                                <Row className="justify-content-center"><img src="/img/multimeter.png" alt="pv-pcs" className="pv-pcs" />
                                </Row>
                                <Row className="mb-4 mt-4 justify-content-center">
                                    {pcsData !== null && <span className="pcsdata">{pcsData.device_id}</span>}
                                </Row>
                            </div>
                        </div>
                        <Col md={8} sm={10} lg={7} className="individual-battery">
                            {(pcsData !== null) && <Table className="power__data">
                                <tbody>
                                    <tr>
                                        <td>温度</td>
                                        <td>{pcsData.temperature}°C</td>
                                    </tr>
                                    <tr>
                                        <td>日射</td>
                                        <td>{pcsData.solar_radiation}mV</td>
                                    </tr>
                                </tbody>
                            </Table>}
                        </Col>
                    </Row>
                </Col>
            </Row>}
        </>
    );
};

export default TableWeather;
